import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStudioDisplay1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconStudioDisplay1"><Path d="M19.25 3.75H4.75C3.64543 3.75 2.75 4.64543 2.75 5.75V13.25C2.75 14.3546 3.64543 15.25 4.75 15.25H19.25C20.3546 15.25 21.25 14.3546 21.25 13.25V5.75C21.25 4.64543 20.3546 3.75 19.25 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M9.25 15.75V20.25H14.75V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconStudioDisplay1;
